<div class="sidebar-container">
  <div class="sidebar-logo-wrap" (click)="goHome()">
    <img [src]="sidebarLogo" class="sidebar-logo" alt="logo" />
  </div>
  <div *ngFor="let item of standaloneItems" class="sidebar-block">
    <div [ngSwitch]="item.type">
      <div *ngSwitchCase="'IMAGE_HEADER'" class="profile-avatar-wrap">
        <img src="{{ urlAvatarProfile(item) }}" class="img-avatar" />
      </div>

      <div *ngSwitchCase="'NAME'" class="profile-name">
        <span>{{ item.title }}</span>
      </div>

      <div *ngSwitchCase="'AGE'" class="profile-age">
        <span>{{ item.title }}</span>
      </div>

      <div *ngSwitchCase="'DROPDOWN'" class="profile-dropdown-card" (click)="open()">
        <div class="profile-dropdown-header">
          <div class="profile-dropdown-title">
            <nb-icon icon="person-outline"></nb-icon>
            <span class="fs-12px">{{ item.title }}</span>
          </div>
          <nb-icon [icon]="openToogle ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
        </div>
        <div class="dropdown" #dropdown>
          <ng-container *ngFor="let data of item?.extra; let i = index">
            <div class="profile-detail-row"
              *ngIf="data.value && !(data.key == 'Tel' && formatPhoneNumber(data) === '')">
              <span class="personal-data-label">{{ data.key }}</span>
              <span class="personal-data-value">
                {{ data.key == 'Tel' ? formatPhoneNumber(data) : data.value }}
              </span>
            </div>
          </ng-container>
          <div class="profile-actions" *ngIf="editModalEnable()">
            <button class="btn-edit" nbButton size="tiny" status="primary"
              (click)="$event.stopPropagation(); openEditModal(dialog)">
              Editar
            </button>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="'WHATSAPP_MAIL'" class="contact-card">
        <span class="contact-title">Contacto</span>
        <div class="contact-actions">
          <button nbButton ghost size="tiny" class="contact-btn" (click)="openLink(item.link)">
            <nb-icon icon="whatsapp" pack="custom-svg"></nb-icon>
          </button>
          <button nbButton ghost size="tiny" class="contact-btn" (click)="openLink(item.data)">
            <nb-icon icon="mail" pack="custom-svg"></nb-icon>
          </button>
        </div>
      </div>
      <ng-container *ngSwitchCase="'DEFAULT'">
        <div *ngIf="item.title === 'Panel de Control' && item.link"
          class="panel-control-direct-item nav-item nav-parent-item"
          [class.is-active]="isActive(item.link)"
          (click)="navigate(item)">
          <div class="nav-item-main">
            <span class="nav-icon-wrap">
              <nb-icon class="nav-icon" [icon]="getItemIcon(item)"></nb-icon>
            </span>
            <span class="nav-label fs-14 color-black">{{ item.title }}</span>
          </div>
        </div>
      </ng-container>

      <div *ngSwitchDefault class="section-title">
        {{ item.title }}
      </div>
    </div>
  </div>

  <div class="sidebar-group-block" *ngIf="user?.roles === 'ROLE_BACKOFFICE_FUNCIONAL'">
    <div class="nav-item nav-parent-item support-parent-item"
      [class.is-active]="formAltaExpanded || isFormAltaRouteActive()" (click)="toggleFormAlta()">
      <div class="nav-item-main">
        <span class="nav-icon-wrap">
          <nb-icon class="nav-icon" icon="settings-2"></nb-icon>
        </span>
        <span class="nav-label fs-16">Suscripciones</span>
      </div>
      <nb-icon class="nav-arrow" [icon]="formAltaExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
    </div>
    <div class="nav-children" [class.is-open]="formAltaExpanded">
      <div (click)="navigateGestionUsuarios()"
        class="nav-child-item support-child-item {{ isGestionUsuariosRouteActive() ? 'is-active' : '' }}">
        <span class="nav-child-label">Gestión de usuarios</span>
      </div>
    </div>

    <div class="nav-children" [class.is-open]="formAltaExpanded">
      <div (click)="navigateToFormAlta()"
        class="nav-child-item support-child-item {{ isFormAltaRouteActive() ? 'is-active' : '' }}">
        <span class="nav-child-label">Formulario alta</span>
      </div>
    </div>
  </div>

  <div *ngFor="let group of groupedMenu" class="sidebar-group-block">
    <div class="nav-item nav-parent-item" [class.is-active]="group.expanded" (click)="toggleGroup(group)">
      <div class="nav-item-main">
        <span class="nav-icon-wrap">
          <nb-icon class="nav-icon" [icon]="getItemIcon(group.item)"></nb-icon>
        </span>
        <span class="nav-label fs-14 color-black">{{ getSectionLabel(group.item) }}</span>
      </div>
      <nb-icon class="nav-arrow" [icon]="group.expanded ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
    </div>

    <div class="nav-children" [class.is-open]="group.expanded">
      <div *ngFor="let child of group.children" (click)="navigate(child)" class="nav-child-item {{ isActive(child.link) ? 'is-active' : '' }} {{ isDisable(child) ? 'disable' : '' }} {{
          child?.class
        }}">
        <span class="nav-child-label">{{ child.title }}</span>
      </div>
      <!-- Opción Staff agregada manualmente al final del grupo Herramientas (solo colegio; antrosport usa el ítem estándar del menú que enlaza a la lista) -->
      <div *ngIf="getSectionLabel(group.item) === 'Herramientas' && !isAntrosport" (click)="redirectStaff()" class="nav-child-item">
        <span class="nav-child-label">Staff</span>
      </div>
    </div>
  </div>

  <div class="sidebar-group-block">
    <div class="nav-item nav-parent-item support-parent-item"
      [class.is-active]="supportExpanded || isSupportRouteActive()" (click)="toggleSupport()">
      <div class="nav-item-main">
        <span class="nav-icon-wrap">
          <nb-icon class="nav-icon" icon="message-square-outline"></nb-icon>
        </span>
        <span class="nav-label fs-16">Soporte</span>
      </div>
      <nb-icon class="nav-arrow" [icon]="supportExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
    </div>

    <div class="nav-children" [class.is-open]="supportExpanded">
      <div (click)="navigateToSupportTickets()"
        class="nav-child-item support-child-item {{ isSupportTicketsActive() ? 'is-active' : '' }}">
        <span class="nav-child-label">Tickets</span>
      </div>
      <div (click)="navigateToSupportTicketCreate()"
        class="nav-child-item support-child-item {{ isSupportTicketCreateActive() ? 'is-active' : '' }}">
        <span class="nav-child-label">Crear Ticket</span>
      </div>
    </div>
  </div>



  <div class="sidebar-group-block">
    <div class="nav-item nav-parent-item support-parent-item"
      [class.is-active]="videoTutorialsExpanded || isVideoTutorialsRouteActive()" (click)="toggleVideoTutorials()">
      <div class="nav-item-main">
        <span class="nav-icon-wrap">
          <nb-icon class="nav-icon" icon="message-square-outline"></nb-icon>
        </span>
        <span class="nav-label fs-16">Video Tutoriales</span>
      </div>
      <nb-icon class="nav-arrow"
        [icon]="videoTutorialsExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
    </div>

    <div class="nav-children" [class.is-open]="videoTutorialsExpanded">
      <a *ngFor="let tutorial of videoTutorials" [href]="tutorial.href"
        class="nav-child-item support-child-item {{ isVideoTutorialActive(tutorial.href) ? 'is-active' : '' }}">
        <span class="nav-child-label">{{ tutorial.title }}</span>
      </a>
    </div>
  </div>

  <div class="sidebar-footer"
    *ngIf="(isbackLogOut() || user.roles !== 'ROLE_PATIENT') && user.roles != 'ROLE_BACKOFFICE' && !isHomePage()">
    <div class="nav-item back-item" (click)="goBack()">
      <div class="nav-item-main">
        <span class="nav-icon-wrap">
          <nb-icon class="nav-icon" icon="arrow-back-outline"></nb-icon>
        </span>
        <span class="nav-label">Volver</span>
      </div>
    </div>
  </div>
</div>

<ng-template #dialog let-data let-ref="dialogRef">
  <div class="turno-modal-overlay">
    <div class="turno-modal-container" [formGroup]="patientForm" [nbSpinner]="isSaveServiceLoading"
      nbSpinnerSize="giant" nbSpinnerStatus="primary">
      <!-- Header moderno -->
      <div class="turno-modal-header">
        <div class="header-content">
          <div class="header-text">
            <h3 class="modal-title">{{ dialogTitle }}</h3>
            <p class="modal-subtitle">Edita los datos personales del paciente</p>
          </div>
        </div>
        <button class="close-button" (click)="ref.close()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
      <!-- Body -->
      <div class="turno-modal-body">
        <h5>Datos Personales</h5>
        <div class="w-100 d-flex flex-row justify-content-between">
          <div class="form-group col-lg-4 col-md-4 col-sm-12">
            <label for="cellphoneCode" class="label">Código de Pais</label>
            <input id="cellphoneCode" class="form-control" formControlName="areaCode" nbInput fullWidth type="number"
              bfValidationStatus placeholder="Ej: 54" [nbAutocomplete]="auto" />
            <nb-autocomplete #auto [handleDisplayFn]="viewHandle" class="expand-up">
              <nb-option *ngFor="let option of filteredCountries$ | async" [value]="option.countryCode">
                <img [src]="option.flag" alt="" width="40px" style="margin-right: 20px" />
                {{ option.code }} | {{ option.countryCode }}
              </nb-option>
            </nb-autocomplete>
          </div>
          <div class="form-group col-lg-7 col-md-7 col-sm-12">
            <label for="cellphoneCode" class="label">Código de Area + Numero de Telefono</label>
            <input class="form-control" id="cellphoneCode" type="text" [formControl]="number" nbInput fullWidth
              bfValidationStatus maxlength="15" minlength="6" appOnlyNumbers />
            <bf-validation-summary [control]="number" [form]="patientForm"></bf-validation-summary>
          </div>
        </div>

        <div class="form-group col-lg-12 col-md-12 col-sm-12">
          <label for="segment" class="label">Segmento</label>
          <nb-select id="segment" formControlName="segment" fullWidth bfValidationStatus
            [placeholder]="segmentSelectMessage">
            <nb-option *ngFor="let type of segments" [value]="type.id">
              {{ type.description | uppercase }}
            </nb-option>
          </nb-select>
        </div>
        <form [formGroup]="formEmail">
          <div>
            <h5>Datos del usuario</h5>
            <div class="d-flex" style="width: 75%">
              <div class="form-group col-lg-8 col-md-8 col-sm-4">
                <label for="cellphoneCode" class="label">Email</label>
                <input class="form-control" id="emailPt" type="text" formControlName="emailPt" nbInput fullWidth
                  bfValidationStatus maxlength="100" (input)="value($event)" />
                <bf-validation-summary [control]="formEmail.get('emailPt')" [form]="formEmail"></bf-validation-summary>
              </div>
              <div class="form-group col-lg-8 col-md-8 col-sm-4">
                <label for="cellphoneCode" class="label">Repetir Email</label>
                <input class="form-control" id="repeatEmail" type="text" [formControl]="repeatEmail" nbInput
                  maxlength="100" fullWidth bfValidationStatus />
                <bf-validation-summary [control]="formEmail.get('repeatEmail')"
                  [form]="formEmail"></bf-validation-summary>
                <div style="height: 8px">
                  <div *ngIf="formEmail.get('repeatEmail').touched">
                    <div *ngIf="formEmail.get('repeatEmail').value !== formEmail.get('emailPt').value"
                      class="text-danger">
                      Los emails no coinciden
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="d-flex flex-row justify-content-center mt-2">
          <button nbButton size="large" class="mr-3 h-30 fz-12" (click)="ref.close()">Cerrar</button>
          <button nbButton size="large" class="mr-5 h-30 fz-12" status="primary"
            [disabled]="patientForm.invalid || formEmail.invalid || isSaveServiceLoading" (click)="callSave(ref)">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
